import {getServerTexts as getTexts, initTexts, texts} from '../../../../Localization/texts';

const entity = 'UI_NEWFORMS';

const en = {
    attachments: 'Attachments',
    number_of_attachments: 'Y (X attachments)',
    filter_option: 'Filters',
    clear_filters: 'Clear',
    format_of_file: 'Format',
    size_of_file: 'Size',
    the_user_who_updated_the_file_last: 'Modified by',
    the_date_the_file_was_created: 'File Creation Date',
    properties_of_file: 'Properties',
    confirm: 'OK',
    cancel: 'Cancel',
    settings_title: 'Show Data',
    clear_settings: 'Reset',
    label_readonly: 'Read-Only',
    label_not_for_sending: "Don't Send",
    tooltip: 'Set by Y X',
    preview: 'Preview',
    download: 'Download',
    rename: 'Rename',
    save: 'Save',
    delete: 'Delete',
    delete_question: 'Delete this file?',
    delete_confirmation: "We won't be able to recover deleted files.",
    delete_yes: 'Yes',
    dataexchange: 'Send by DataExchange',
    drop_file: 'Drop files here to attach or',
    browse: 'browse',
    drop_here: 'Drop your file here',
    file_saved: 'The file was uploaded successfully',
    empty_state_message: 'Attached files will appear here',
    empty_state__search_message: 'We did not find attachments that match your search.',
    attach_files: 'Add Attachments',
    top_100: 'See 100 attachments from all the results that match your',
    unsupported_format: 'The format you chose is not supported.',
    search_placeholder: 'Search...',
    history: 'History',
    statuses: 'Statuses',
    cahnges: 'Cahnges',
    status_cahnged: 'X changed the W to Y',
    single_change_log: 'X changed the W field from Y to Z',
    status_created: 'Created by X',
    changed_fields_count: 'X changed Y fields',
    change_bullet: 'X from Y to Z',
    file_upload: 'Uploading your file...',
    status_bullet: 'X to Y',
    change_wo_prev_val: 'X changed the W field to Z',
    changes_empty_state: 'Changes will appear here',
    changes_empty_state_search:
        'We did not find results that match your search. Check your spelling and try again.',
    change_wo_curr_val: 'X changed the W field from Y to an empty field',
    files_saved: 'The files were saved successfully',
    files_upload: 'Uploading your files...',
    file_download: 'Downloading your file…',
    promo_title: 'Quick Access',
    promo_attachments: 'Check out the new and easy way to add attachments to your documents.',
    promo_confirm: 'OK, got it',
    promo_show: 'Show me',
    promo_history: 'Quickly view the history and changes to your document.',
    cantChangeErrorMsg:
        'You cannot revise the attached file as it has defined as Read Only by X. To release the file for editing, contact your system manager'
};

const he = {
    attachments: 'נספחים',
    number_of_attachments: 'Y (X נספחים)',
    filter_option: 'סינון',
    clear_filters: 'ניקוי',
    format_of_file: 'פורמט',
    size_of_file: 'גודל',
    the_user_who_updated_the_file_last: 'עודכן ע"י',
    the_date_the_file_was_created: 'תאריך יצירת מסמך',
    properties_of_file: 'מאפיינים',
    confirm: 'אישור',
    cancel: 'ביטול',
    settings_title: 'נתונים להצגה',
    clear_settings: 'איפוס',
    label_readonly: 'לקריאה בלבד',
    label_not_for_sending: 'לא לשליחה',
    tooltip: 'הוגדר ע"י X Y',
    preview: 'תצוגה מקדימה',
    download: 'הורדה',
    rename: 'שינוי שם',
    save: 'שמירה',
    delete: 'מחיקה',
    delete_question: 'למחוק את הקובץ?',
    delete_confirmation: 'המידע שימחק יאבד ולא נוכל לשחזר אותו.',
    delete_yes: 'כן',
    dataexchange: 'משלוח בממשק אלקטרוני',
    drop_file: 'אפשר לגרור לכאן קבצים או',
    browse: 'לבחור קובץ מתיקייה',
    drop_here: 'לשחרר את הקובץ כאן',
    file_saved: 'הקובץ נשמר בהצלחה',
    empty_state_message: 'כשיהיו נספחים לתעודה, הם יופיעו כאן',
    empty_state__search_message: 'אין נספחים שמתאימים לחיפוש שלך. כדאי לבדוק את האיות',
    attach_files: 'הוספת קובץ',
    top_100: 'מוצגים כאן 100 נספחים מתוך כל הנספחים המתאימים',
    unsupported_format: 'הפורמט שבחרת לא נתמך.',
    history: 'יומן שינויים',
    statuses: 'סטטוסים',
    changes: 'שינויים',
    search_placeholder: 'חיפוש...',
    status_cahnged: 'הW שונה על ידי X ל- Y',
    single_change_log: 'השדה W שונה על ידי X מ- Y ל- Z',
    status_created: 'יצירה ראשונית על ידי X',
    changed_fields_count: 'X שדות שונו על ידי Y',
    change_bullet: 'X מ - Y ל - Z',
    file_upload: 'מעלים את הקובץ שלך...',
    status_bullet: 'X ל- Y',
    change_wo_prev_val: 'השדה W שונה על ידי X ל- Z',
    changes_empty_state: 'שינויים בתעודה יופיעו כאן.',
    changes_empty_state_search: 'אין נתונים המתאימים לחיפוש. כדאי לבדוק את האיות שוב.',
    change_wo_curr_val: 'השדה W שונה מ-Y לשדה ריק על ידי X.',
    files_saved: 'הקבצים נשמרו בהצלחה',
    files_upload: 'מעלים את הקבצים שלך...',
    file_download: 'אנחנו מורידים את הקובץ...',
    promo_title: 'גישה מהירה',
    promo_attachments: 'דרך חדשה ונוחה לצרף נספחים לתעודות שלך.',
    promo_confirm: 'הבנתי',
    promo_show: 'ספרו לי עוד',
    promo_history: 'מבט מהיר על היסטוריית השינוי של התעודה.',
    cantChangeErrorMsg:
        'ינך יכול לשנות את הקובץ המצורף כפי שהוגדר כקריאה בלבד על ידי X. כדי לשחרר את הקובץ לעריכה, פנה למנהל המערכת שלך'
};

const fallbacks = {en, he};

export const mapping = {
    1: 'attachments',
    2: 'number_of_attachments',
    3: 'filter_option',
    4: 'clear_filters',
    5: 'format_of_file',
    6: 'size_of_file',
    7: 'the_user_who_updated_the_file_last',
    8: 'the_date_the_file_was_created',
    9: 'properties_of_file',
    10: 'confirm',
    11: 'cancel',
    12: 'settings_title',
    13: 'clear_settings',
    14: 'label_readonly',
    15: 'label_not_for_sending',
    16: 'tooltip',
    17: 'preview',
    18: 'download ',
    19: 'rename',
    20: 'save',
    21: 'delete',
    22: 'delete_question',
    23: 'delete_confirmation',
    24: 'delete_yes',
    25: 'dataexchange',
    26: 'drop_file',
    27: 'browse',
    28: 'drop_here',
    29: 'file_saved',
    30: 'empty_state_message',
    31: 'attach_files',
    32: 'top_100',
    33: 'unsupported_format',
    34: 'history',
    36: 'statuses',
    37: 'changes',
    38: 'search_placeholder',
    66: 'status_cahnged',
    67: 'single_change_log',
    68: 'status_created',
    69: 'changed_fields_count',
    70: 'change_bullet',
    71: 'empty_state__search_message',
    72: 'file_upload',
    73: 'status_bullet',
    87: 'file_download',
    88: 'change_wo_prev_val',
    89: 'changes_empty_state',
    90: 'changes_empty_state_search',
    91: 'change_wo_curr_val',
    92: 'files_saved',
    93: 'files_upload',
    94: 'promo_title',
    95: 'promo_attachments',
    96: 'promo_confirm',
    97: 'promo_show',
    98: 'promo_history'
};

export const getServerTexts = () => getTexts(entity, mapping);

initTexts(entity, fallbacks);

export default texts[entity];
